var _circle, _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1580_763)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.528 217.439L239.512 110.927L313.464 176.601L349.336 213.024L373.066 280.353L355.406 341.06L327.26 357.064C299.458 365.9 283.11 379.691 256.068 379.691C229.026 379.691 221.3 367.55 221.3 367.55L182.117 349.338L151.212 316.225L146.797 266.005L170.528 217.439Z",
    fill: "#FEF4E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1580_763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 91,
    width: 248,
    height: 289
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.766 91.6113H382.114V379.691H135.766V91.6113Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1580_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.68 97.9248C209.897 184.883 143.07 224.435 143.07 289.166C143.07 331.653 175.691 358.825 221.046 372C207.671 363.301 190.787 344.69 190.787 327.152C190.787 293.946 207.554 283.189 218.052 247.13C243.237 265.463 245.317 293.036 245.317 293.036C245.317 293.036 275.206 243.391 265.768 189.745C315.681 228.969 334.198 268.062 333.926 300.538C333.635 334.588 312.853 361.358 291.906 373.378C337.561 367.794 374.819 332.53 374.819 288.51C374.819 223.771 331.72 175.75 231.68 97.9248Z",
    stroke: "#4045A1",
    strokeWidth: 14.6355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.484 290.37C143.484 332.857 176.105 360.029 221.46 373.204C208.085 364.505 191.201 345.894 191.201 328.356C191.201 295.15 207.968 284.393 218.466 248.334C243.651 266.667 245.731 294.24 245.731 294.24C245.731 294.24 275.621 244.595 266.182 190.949C316.095 230.173 334.612 269.266 334.34 301.742C334.049 335.792 313.267 362.562 292.32 374.582C337.976 368.998 375.233 333.735 375.233 289.714",
    stroke: "black",
    strokeWidth: 14.6355,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1580_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.7462c68303efd3ce96af4298af01b042.svg";
export { ForwardRef as ReactComponent };